import { useMemo } from "react";
import type { MapPinDataArray } from "./MapPinData";

export type MapBounds = {
    center: { lat: number; lng: number } | undefined;
    bounds: google.maps.LatLngBoundsLiteral | undefined;
};

export function useMapBounds(pins: MapPinDataArray): MapBounds {
    return useMemo(() => {
        if (pins.length === 0) {
            return {
                center: undefined,
                bounds: undefined,
            };
        }

        if (pins.length === 1) {
            const pin = pins[0];
            return {
                center: { lat: pin.lat, lng: pin.lng },
                bounds: undefined,
            };
        }

        // Calculate bounds for multiple pins
        let north = -90;
        let south = 90;
        let east = -180;
        let west = 180;
        let totalLat = 0;
        let totalLng = 0;

        for (const pin of pins) {
            north = Math.max(north, pin.lat);
            south = Math.min(south, pin.lat);
            east = Math.max(east, pin.lng);
            west = Math.min(west, pin.lng);
            totalLat += pin.lat;
            totalLng += pin.lng;
        }

        const center = {
            lat: totalLat / pins.length,
            lng: totalLng / pins.length,
        };

        const bounds: google.maps.LatLngBoundsLiteral = {
            north,
            south,
            east,
            west,
        };

        return {
            center,
            bounds,
        };
    }, [pins]);
}
